import { AfterViewInit, Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from "@angular/core";
import "./v-toggle.component.scss";

@Component({
    selector: "v-toggle",
    template: require("./v-toggle.component.html")
})
export class VToggleComponent implements OnInit, AfterViewInit {

    @Input() value: boolean;

    @Output() valueChange = new EventEmitter<boolean>();
    @Output() onChanged = new EventEmitter<boolean>();

    @HostBinding("class.disabled") @Input() disabled: boolean;
    @ViewChild('labelContainer', { static: true }) labelContainer: ElementRef;

    constructor() { }

    ngOnInit(): void { }

    ngAfterViewInit() {
        this.removeElementsIfEmpty();
    }

    toggle(event?: MouseEvent): void {
        event?.stopPropagation();

        if (this.disabled) {
            return;
        }

        this.value = !this.value;

        this.valueChange.emit(this.value);
        this.onChanged.emit(this.value);
    }

    // ---

    private removeElementsIfEmpty(): void {
        if (!this.labelContainer?.nativeElement?.innerHTML) {
            this.labelContainer.nativeElement.remove();
        }
    }
}
